// Copyright (c) Ensho Health, 2022 to present

import api from '../api';
import { NOTIFICATION_TYPES } from './notification.action.js';

export function sendOrder(orderData) {
  let errorMessage = {};
  return async () => {
    let requiredFields = [
      'algorithm',
      'type',
      'physicianId',
      'physicianName',
      'physicianOffice',
      'physicianAccountNumber',
      'physicianEmail',
      'physicianUpdate'
    ];
    if (orderData.type === '_SINGLE_PATIENT') {
      requiredFields.push(
        'patient_record',
        'patientFirstname',
        'patientLastname',
        'patientSex',
        'patientDob',
        'patienHcn'
      );
    }
    for (let field of requiredFields) {
      if (
        orderData[field] === null ||
        orderData[field] === '' ||
        (field === 'patient_record' && !orderData.patient_record.name)
      ) {
        errorMessage[field] = true;
      }
    }
    if (Object.keys(errorMessage).length === 0) {
      const orderFormData = new FormData();
      orderFormData.append('service', orderData.service);
      orderFormData.append('patient_record', orderData.patient_record);
      orderFormData.append('patientFirstname', orderData.patientFirstname);
      orderFormData.append('patientLastname', orderData.patientLastname);
      orderFormData.append('patientMiddlename', orderData.patientMiddlename);
      orderFormData.append('patientSex', orderData.patientSex);
      orderFormData.append('patientDob', orderData.patientDob);
      orderFormData.append('patienHcn', orderData.patienHcn);
      orderFormData.append('physicianId', orderData.physicianId);
      orderFormData.append('physicianName', orderData.physicianName);
      orderFormData.append('physicianOffice', orderData.physicianOffice);
      orderFormData.append(
        'physicianAccountNumber',
        orderData.physicianAccountNumber
      );
      orderFormData.append('physicianEmail', orderData.physicianEmail);
      orderFormData.append('physicianPhone', orderData.physicianPhone);
      orderFormData.append('physicianFax', orderData.physicianFax);
      orderFormData.append('physicianUpdate', orderData.physicianUpdate);
      try {
        await api.order.sendOrder(orderFormData);
      } catch (e) {
        errorMessage.bnError = true;
        const serverNotification = {
          message: e.message,
          info: {
            location: 'order.action.sendOrder',
            physicianId: orderData.physicianId,
            physicianName: orderData.physicianName,
            lab: orderData.service,
            labType: orderData.type
          },
          type: NOTIFICATION_TYPES.ERROR
        };
        await api.notification.sendNotification(serverNotification);
        throw errorMessage;
      }
    } else {
      throw errorMessage;
    }
  };
}
